import { useState } from "react";
import Plot from "react-plotly.js";
import { ColorPicker } from "shared-component/color-picker";

type TimeSeriesProps = {
  data: any;
  range: string[];
  title: any;
  width: any;
  height: any;
};

const TimeSeries = (props: TimeSeriesProps) => {
  const [, setLineColor] = useState<string>('');
  const updateLineColor = (value: string, index: number) => {
    props.data[index] = {
      ...props.data[index],
      line: {
        color: value
      }
    };
    setLineColor(value)
  }

  return (
    <>
      <Plot
        style={{ display: "flex", justifyContent: "center" }}
        data={props.data}
        layout={{
          title: props?.title,
          width: props?.width,
          height: props?.height,
          // Adjust margin to move the heatmap to the top
          margin: {
            t: 25, // Adjust this value as needed
            l: 25,
            r: 25,
            b: 25
          },
          xaxis: {
            range: props.range,
            type: 'date',
            automargin: true,
          },
          yaxis: {
            autorange: true,
            type: 'linear',
            automargin: true,
          }
        }}
      />
      {props?.data?.length > 0 && <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "center" }}>
        {props?.data?.map((item: any, index: number) => {
          return (
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "center" }}>
              <span>{`${item.name}:`}</span>
              <span><ColorPicker setChartColor={updateLineColor} index={index}/></span>
            </div>
          )
        })}
      </div>}
    </>

  );
};

export default TimeSeries;